/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: TestimonialPage
 * Page name: Testimonial page
 * Page Description: This is the Testimonial page of the website of Ekathva Innovations.
 */

import React,{ useEffect } from 'react'
import MetaTags from "react-meta-tags"
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Card, Button, Col, Row, Container, Image } from 'react-bootstrap'
import Aos from 'aos'
import Navbar from 'components/Navbars/Navbar'
import LandingPageTestimonials from 'components/Headers/LandingPageTestimonials'
import Footer from 'components/Footers/Footer'

import 'assets/style/Style.css'

import {ReactComponent as Comma} from "assets/images/Testimonial/Invertedcomma.svg"

import Aditya from 'assets/images/Testimonial/Aditya.jpg'
import Kiran from 'assets/images/Testimonial/Kiran.jpeg'
import Nakul from 'assets/images/Testimonial/Nakul.JPG'
import Niveditha from 'assets/images/Testimonial/Niveditha.jpg'
import Upendra from 'assets/images/Testimonial/Upendra.jpg'
import Vidyashankar from 'assets/images/Testimonial/Vidyashankar.JPEG'
import Gowrav from 'assets/images/Testimonial/gowrav.jpeg'
import Sachin from 'assets/images/Testimonial/Sachin.jpg'

function TestimonialsPage() {

  useEffect( () => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
    <MetaTags>
    <title>Testimonials - What our clients say about our work| Ekathva Innovations Pvt Ltd  </title>
    </MetaTags>
    <Navbar/>
    <LandingPageTestimonials/>

    <div className='homepage_spacing' >
    <br/>
    <Row>
    <Col>
    <Card className=' testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>


    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image variant="top" src={Nakul} alt='Nakul Acharya ' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col>
    </Col>
    </Row>
    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
    "ಏಕತ್ವ ಇನೊವೇಶನ್ಸ್" ಹೆಸರಿಗೆ ತಕ್ಕಂತೆ ಏಕತೆ, ಬುದ್ದಿವಂತಿಕೆ, ಚುರುಕುತನ, ಹೀಗೆ ಎಲ್ಲಾ ವಿಭಾಗದಲ್ಲಿಯು ಸಾಮಥ್ರ್ಯ
    ಮತ್ತು ಪರಿಣಿತಿಯನ್ನು ಹೊಂದಿರುವ ಬುದ್ದಿವಂತ, ಪ್ರಬುದ್ಧ ಯುವ ಉದ್ಯಮಿಗಳ ಸರ್ವಶ್ರೇಷ್ಠ ತಂಡ.ನಮ್ಮ ಸಂಸ್ಥೆ ವಿ-ಟೆಕ್
    ಇಂಜಿನಿಯರ್ಸ್ ಮತ್ತು ವಿ-ಟೆಕ್ ಗ್ರೂಪ್ ಆಫ್ ಕಂಪನೀಸ್ ನೊಂದಿಗೆ ಕಳೆದ ಎರಡು ವರುಷದಿಂದ ನಿರಂತರ ಸಂಪರ್ಕದಲ್ಲಿರುವ
    ಈ ಯುವಕರು ನಮಗೆ ಸಿಕ್ಕಿದ್ದೆ ಒಂದು ಅಚ್ಚರಿ ಮತ್ತು ಅತ್ಯಂತ ಹೆಮ್ಮೆಯ ಸಂಗತಿ.<br/>
    </strong>
    </p>
    <p className='homepagetestimonial_contentfont'>
    <strong>
    ಇಂದು ವಿ-ಟೆಕ್ ಗ್ರೂಪ್‍ನ ಎಲ್ಲಾ ವೆಬ್‍ಸೈಟ್ ವಿನ್ಯಾಸ, ಮಾಹಿತಿ ಪುಸ್ತಕದ ವಿನ್ಯಾಸ ಸೇರಿದಂತೆ ಹತ್ತು ಹಲವು ಮಹತ್ವದ
    ಜವಬ್ದಾರಿಯನ್ನು ನಿಭಾಯಿಸುತ್ತಿರುವುದು ಹೆಮ್ಮೆಯ ವಿಚಾರ.<br/>
    </strong>
    </p>
    <p className='homepagetestimonial_contentfont'>
    <strong>
    ಒತ್ತಡದ ನಡುವೇ, ಕಾಲಮಿತಿಯೊಂದಿಗೆ ಕೊಟ್ಟಕೆಲಸವು ಎಲ್ಲಿಯೂ ತಪ್ಪಾಗದಂತೆ ಸಮಯದೊಳಗೆ ಅತ್ಯುತ್ತಮವಾಗಿ ಮುಗಿಸುವ
    ಇವರ ತಂಡಕ್ಕೆ ನಮ್ಮ ಸಂಸ್ಥೆಯಿಂದ ಶುಭಹಾರೈಕೆಗಳು. ನಿಮ್ಮ ಯಶಸ್ಸು ಹೀಗೆ ಮುಂದುವರಿಯಲಿ.<br/>
    </strong>
    <br/>
    <span className='it_ssnamecolor'> ನಕುಲ್ ಆಚಾರ್ಯ,</span>
    <span className='aboutus_fontbold' ><br/>ವಿ-ಟೆಕ್ ಇಂಜಿನಿಯರ್ಸ್,</span>
    <span><br/>ಕುಂಟವಳ್ಳಿ</span>
    </p>
    </div>
    </Card>
    </Col>

    <Col>
    <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image variant="top" src={Upendra} alt='Prof H A Upendra Kumar' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>


    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
    I thank you and your organization for developing the web site for our ISVM National Symposium.
    The website is designed perfectly and user friendly. What I appreciated was your involvement,
    providing necessary information, developing the website as per our needs and suggesting further
    improvement. You took personal care and developed the web site. You took trouble visiting our
    college many times to ensure that the website starts working without any hitch. Thanks a lot
    for an attractive and user-friendly website that shall play a major role in the success of the
    National Symposium.</strong>
    </p>
    <p className='homepagetestimonial_contentfont'>
    <span className='it_ssnamecolor'>Prof H A Upendra,</span>
    <span className='aboutus_fontbold'>
    <br/>CO Chair of ISVM convention,
    </span>
    <span>
    <strong>
    <br/>Head, Dept of Veterinary Medicine, KVAFSU,<br/> Bangalore
    </strong>
    </span>
    </p>
    </div>
    </Card>
    </Col>
    </Row>

    <Row>
    <Col>
    <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image variant="top" src={Kiran} alt='CS Kiran N P' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>

    <p className='homepagetestimonial_contentfont'>
    <br/><strong>
    I thank Team Ekathva for providing my organization a tracking software - DSC Tracker.
    Simple and user-friendly interface to track my client's DSC's and other important documents,
    which made my work simpler, easy to keep track of DSCs, Documents and find it in time. Kudos to the team.
    </strong>
    </p>
    <br/>
    <p className='homepagetestimonial_contentfont'>
    <span className='it_ssnamecolor'>CS Kiran. N.P.</span>
    <span className='aboutus_fontbold'>
    <br/>Company Secretary in Practice,
    </span>
    <span>
    <strong>
    <br/>Shivamogga
    </strong>
    </span>
    </p>
    </div>
    </Card>
    </Col>

    <Col>
    <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image id='shadow' variant="top" src={Vidyashankar} alt='Dr. M H Vidyashankar' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>


    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
    ಮಲೆನಾಡಿನ ಹುಡುಗರೆ ಸೇರಿ ನಿರ್ಮಿಸಿದ ಒಂದು ಸಂಸ್ಥೆ ಏಕತ್ವ ಇನ್ನೋವೇಶನ್ಸ್ ಹೆಸರೇ ಹೇಳಿದಂತೆ ಏಕತ್ವವನ್ನು
    ಸಾರುತ್ತಿದ್ದಾರೆ, ವೆಬ್ ಸೈಟ್ ಡಿಸೈನಿಂಗ್, ಕಾರ್ಯಾಗಾರಗಳು ಇನ್ನಿತರ ಸಮಾಜಮುಖಿ ಕಾರ್ಯಕ್ರಮದೊಂದಿಗೆ ಮಲೆನಾಡಿನ
    ಹುಡುಗರು ನಮ್ಮ ಜಿಲ್ಲೆಗೆ ಹೆಮ್ಮೆ ಎನಿಸಿದ್ದಾರೆ. ವಿಶ್ವ ಭೂಷಣ ವಿಶ್ವಸ್ಥ ಮಂಡಳಿಯ ಅಧ್ಯಕ್ಷನಾಗಿ ನನಗೆ ಇವರ ಕೆಲಸ
    ಸಂತೋಷದಾಯಕವಾಗಿದೆ ನಮ್ಮ ವೆಬ್ ಸೈಟ್ ನಿರ್ಮಾಣ, ಮತ್ತು ನಿರ್ವಹಣೆ ಇದೇ ತಂಡವೇ ಮಾಡುತ್ತಿದ್ದು ಉತ್ಕೃಷ್ಟವಾದ
    ಕೆಲಸವನ್ನು ಮಾಡಿರುವುದು ಮತ್ತು ಮಾಡುತ್ತಿರುವುದು ನಮ್ಮ ಸಂಸ್ಥೆಯ ಎಲ್ಲ ಸದಸ್ಯರಿಗೂ ಸಂತೋಷವನ್ನುಂಟು ಮಾಡಿದೆ,
    ಇವರ ಪ್ರತಿಭೆ ಇನ್ನೂ ಬೆಳೆಯಲಿ, ಮಲೆನಾಡಿನಲ್ಲಿ ಅಲ್ಲದೆ ರಾಜ್ಯದಲ್ಲೂ ಹೆಸರು ಮಾಡಲಿ ಎಂದು ಹಾರೈಸುವ
    <br/>
    </strong>
    <br/>
    <span className='it_ssnamecolor'>
    ಡಾ. ವಿದ್ಯಾಶಂಕರ್ ಎಂ. ಹೆಚ್,
    </span>
    <span className='aboutus_fontbold'>
    <br/>ಅಧ್ಯಕ್ಷರು, ವಿಶ್ವ ಭೂಷಣ ವಿಶ್ವಸ್ತ ಮಂಡಳಿ,
    </span>
    <span>
    <strong>
    <br/>ಭದ್ರಾವತಿ
    </strong>
    </span>
    </p>
    </div>
    </Card>

    </Col>
    </Row>

    <Row>
    <Col>
    <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image id='shadow' variant="top" src={Gowrav} alt='Gowrav Bharghav' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>


    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
    Heartfelt thanks to Ekathva Innovations for an amazing design of PCB circuits
    and remote control units with onboard long range wireless connectivity enabled
    us in rapid prototyping our vision of automating the existing agricultural practices
    of pesticide sprayer with our innovative sprayer robots. The support from the team with
    timely response and open for customization during the prototyping is very well appreciated.
    Looking forward to working along with this great team in making our product more farmer
    friendly and many more collaborations in near future.
    <br/>
    </strong>
    <br/>
    <span className='it_ssnamecolor'>
    Gowrav Bhargav K R,
    </span>
    <span className='aboutus_fontbold'>
    <br/>Sri Gowri Bhargava Private Limited,
    </span>
    <span>
    <strong>
    <br/>Koppa
    </strong>
    </span>
    </p>
    </div>
    </Card>
    </Col>

    <Col>
    <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
    <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image id='shadow' variant="top" src={Sachin} alt=' Sachin Hegdekudgi' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>

    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
    Our collaboration with Ekathva Innovations from the past two years is very eventful.
    With this team, we designed and developed my company website and now designing and developing
    the Mobile application which is going to be farmer-friendly and in line with our company's motto
    to serve the farmer community. The team at Ekathva always works with a structured approach with
    an end result in mind. Time and again they have surprised me with the quality of work.
    <br/>
    </strong>
    <br/>
    <span className='it_ssnamecolor'>
    Sachin Hegdekudgi,
    </span>
    <span className='aboutus_fontbold'>
    <br/>RootsGoods (OPC) Pvt Ltd,
    </span>
    <span>
    <strong>
    <br/>Bengaluru
    </strong>
    </span>
    </p>
    </div>
    </Card>
    </Col>
    </Row>

            <Row>
                <Col>
                <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
                <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >
    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image id='shadow' variant="top" src={Niveditha} alt='Niveditha' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>


    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
        The excellent website design for our institute displays the hallmark of professionalism of the web developers and
        designers at Ekathva Innovations. The various portals, navigation options, highlight points, space for videos, and
        images in our website have completely fulfilled our requirements to make our website easily accessible and more user-friendly.
        The responses of the team pertaining to our requests for necessary modifications are marvelous and worthy of appreciation.
        The website includes a blog, which is very much blogger- friendly and user-friendly, and along with a very professional logo
        design work which also deserves sincere appreciation. Thank you so much for working with us.
        <br/>
    </strong>
    <br/>
    <br/>
    <span className='it_ssnamecolor'>
    Niveditha,
    </span>
    <span className='aboutus_fontbold'>
    <br/>
    Assistant Professor,
    </span>
    <span>
    <strong>
    <br/>
    GFGC Kalasa
    </strong>
    </span>
    </p>
    </div>
    </Card>
    </Col>

    <Col>
    <Card className='testimonial_cardsize'>
    <Row className='homepagetestimonial_imagestyle'>
    <Col md={2}>
    </Col>
    <Col md={6}>
                <Comma className='homepagetestimonial_commasize svgcolor' roundedCircle />
    </Col>
    <Col md={4}>
    </Col>
    </Row>

    <div data-aos="fade-up" className='homepagetestimonial_contentpadding' >

    <Row>
    <Col >
    </Col>
    <Col style={{paddingLeft:70}} >
    <Image id='shadow' variant="top" src={Aditya} alt=' Aditya K' className='homepagetestimonial_imagesizing' roundedCircle />
    </Col>
    <Col >
    </Col>
    </Row>

    <p className='homepagetestimonial_contentfont'>
    <br/>
    <strong>
        I found the General Development board is very useful to learn and explore microcontrollers and Dev Boards.
        This GDB can be used for mini projects also. It is very cost-effective and easy to use because If you keep
        buying all components separately for learning one microcontroller it will cost more but when we get all the
        components on a single board I feel that it is very useful. So, by having this one board we can interface this
        with the different chips as a beginner. And also, it's so compact, instead of carrying too many components, we
        can easily carry a single board. Best one if you want to explore any microcontroller based boards
        <br/>
    </strong>
    <br/>
    <br/>
    <span className='it_ssnamecolor'>
    Aditya K,
    </span>
    <span className='aboutus_fontbold'>
    <br/>Electronic Hobbyist,
    </span>
    <span>
    <strong>
    <br/>Shivamogga
    </strong>
    </span>
    </p>
    </div>
    </Card>
    </Col>
            </Row>

    </div>
    <Footer/>
    </div>
  )
}

export default TestimonialsPage
